import React from "react";
import { Loader2, X } from "lucide-react";
import ImageListEditor from "./ImageListEditor";

const Field = ({ label, children }) => (
  <div>
    <label className="text-sm font-bold text-slate-600">{label}</label>
    {children}
  </div>
);

const ProductForm = ({ isNew, form, setForm, categories, saving, onSubmit, onCancel }) => {
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
  const setImages = (fn) => setForm((f) => ({ ...f, images: fn(f.images) }));

  return (
    <form onSubmit={onSubmit} className="rounded-2xl border-2 border-[#f7941e]/40 bg-orange-50/50 p-5 sm:p-6 space-y-4" data-testid="product-form">
      <div className="flex items-center justify-between">
        <h3 className="font-display text-lg font-extrabold text-slate-800">
          {isNew ? "Neues Produkt anlegen" : "Produkt bearbeiten"}
        </h3>
        <button type="button" onClick={onCancel} data-testid="product-form-cancel"
          className="h-9 w-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-slate-50">
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Name *">
          <input required value={form.name} onChange={set("name")} data-testid="product-form-name"
            className="input-soft mt-1 h-11 w-full" placeholder="z. B. Drachenfigur" />
        </Field>
        <Field label="Variante">
          <input value={form.variant} onChange={set("variant")} data-testid="product-form-variant"
            className="input-soft mt-1 h-11 w-full" placeholder="z. B. Frostwing" />
        </Field>
        <Field label="Preis (€) *">
          <input required value={form.price} onChange={set("price")} data-testid="product-form-price"
            className="input-soft mt-1 h-11 w-full" placeholder="z. B. 79,90" inputMode="decimal" />
        </Field>
        <Field label="Stückzahl auf Lager *">
          <input required type="number" min="0" step="1" value={form.stock} onChange={set("stock")} data-testid="product-form-stock"
            className="input-soft mt-1 h-11 w-full" placeholder="z. B. 5" />
        </Field>
        <Field label="Kategorie *">
          <input required list="product-categories" value={form.category} onChange={set("category")}
            data-testid="product-form-category" className="input-soft mt-1 h-11 w-full" placeholder="z. B. Figuren" />
          <datalist id="product-categories">
            {categories.map((c) => <option key={c} value={c} />)}
          </datalist>
        </Field>
        <Field label="Badge">
          <select value={form.badge} onChange={set("badge")} data-testid="product-form-badge" className="input-soft mt-1 h-11 w-full">
            <option value="">Kein Badge</option>
            <option value="Neu">Neu</option>
            <option value="Sofort lieferbar">Sofort lieferbar</option>
          </select>
        </Field>
        <label className="sm:col-span-2 flex items-center gap-3 cursor-pointer select-none">
          <input type="checkbox" checked={form.active} onChange={set("active")} data-testid="product-form-active"
            className="h-5 w-5 accent-[#3f8f2a]" />
          <span className="text-sm font-bold text-slate-600">Im Shop bestellbar (bei Stückzahl 0 automatisch „Ausverkauft“)</span>
        </label>
      </div>

      <Field label="Beschreibung">
        <textarea rows={3} value={form.description} onChange={set("description")} data-testid="product-form-description"
          className="input-soft mt-1 w-full py-3" placeholder="Kurze Produktbeschreibung ..." />
      </Field>

      <ImageListEditor images={form.images} onChange={setImages} />

      <div className="flex justify-end gap-3 pt-2">
        <button type="button" onClick={onCancel}
          className="rounded-full px-6 h-11 font-bold text-slate-600 border border-slate-200 hover:bg-slate-50">
          Abbrechen
        </button>
        <button type="submit" disabled={saving} data-testid="product-form-save"
          className="inline-flex items-center gap-2 rounded-full px-6 h-11 font-bold text-white bg-gradient-to-r from-[#63b93c] to-[#3f8f2a] shadow-md hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          Speichern
        </button>
      </div>
    </form>
  );
};

export default ProductForm;
